<script>
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()

    const example = ['2n', 'odd', 'n+5', '2n+6', '-n+8', '-2n+10'];
</script>

<style>
    div {
        font-size: 0.65rem;
        margin-bottom: 0.5rem;
    }

    button {
        margin: 0.2rem;
        padding: 0.125em 0.5em;
        border: 1px solid var(--grey);
        border-radius: 3px;
        cursor: pointer;
        transition: all 0.25s;
    }

    button:hover,
    button:focus {
        background-color: var(--white);
    }
</style>

<div>
    Try me: {#each example as e}<button on:click={() => dispatch('update', e)}>{e}</button>{/each}
</div>
